export default __webpack_public_path__ + "img/a3342fabef898738a47741373469b516.png";